module.exports = __webpack_public_path__ + "static/media/icons-arrowright.fe7a7322.svg";